import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CoreState } from '../reducers';

export const selectCoreState = createFeatureSelector<CoreState>('core');

export const selectNotification = createSelector(
  selectCoreState,
  (state: CoreState) => state.notification,
);

export const selectSlug = createSelector(
  selectCoreState,
  (state: CoreState) => state.slug,
);

export const selectAccountSlug = createSelector(
  selectCoreState,
  (state: CoreState) => state.accountSlug,
);

export const selectLanguaje = createSelector(
  selectCoreState,
  (state: CoreState) => state.languaje,
);

export const selectLoading = createSelector(
  selectCoreState,
  (state: CoreState) => state.loading,
);
